/* epi-merch-badges.js — Merch badge click → dialog popup */
(function () {
  'use strict';

  const dialog = document.getElementById('epi-merch-badge-dialog');
  if (!dialog) return;

  const dataEl = document.getElementById('epi-merch-badge-data');
  const badgeData = dataEl ? JSON.parse(dataEl.textContent) : [];

  function openBadge(slug) {
    const badge = badgeData.find((b) => b.slug === slug);
    if (!badge) return;

    dialog.querySelector('[data-badge-title]').textContent = badge.popup_title || badge.name;
    dialog.querySelector('[data-badge-body]').innerHTML = badge.popup_body || '';

    const cta = dialog.querySelector('[data-badge-cta]');
    if (badge.popup_link_url) {
      cta.href = badge.popup_link_url;
      cta.textContent = badge.popup_link_label || '';
      cta.hidden = false;
    } else {
      cta.hidden = true;
    }

    dialog.showModal();
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-merch-badge]');
    if (!btn) return;
    e.preventDefault();
    openBadge(btn.dataset.badgeSlug);
  });

  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) dialog.close();
  });

  const closeBtn = dialog.querySelector('[data-badge-close]');
  if (closeBtn) closeBtn.addEventListener('click', () => dialog.close());
})();
